import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    width: "100%",
    backgroundColor: "#552B13",
//   border: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid #9c791979`,
  "&:not(:last-child)": {
    // borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1.2rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "#552B13",
  flexDirection: "center",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
//   borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CustomizedAccordions({ data }) {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      {data.map((item, index) => {
        const { accordionName, headerChild, bodyChild } = item;
        return (
          <Accordion
          key={`${accordionName}${index}`}
            expanded={expanded === accordionName}
            onChange={handleChange(accordionName)}
          >
            <AccordionSummary
              aria-controls={`${accordionName}${index}-content`}
              id={`${accordionName}${index}-header`}
            >
              {headerChild}
            </AccordionSummary>
            <AccordionDetails>{bodyChild}</AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
}
